import { jsonProperty, Serializable } from 'ts-serializable';

export default class CreateMessageDto extends Serializable {
  @jsonProperty(Number, null) documentTypeId: number | null = null;
  @jsonProperty(Number, null) documentId: number | null = null;
  @jsonProperty(String, null) message: string | null = null;
}
